<template>
<section class="freebook_consultant sc_consultant_ul gray_section">
    <div class="wrap">
        <h2 class="section_title" style="margin-bottom:20px">프리북 추천 컨설턴트</h2>
    </div>

    <swiper v-show="scItems.length > 0"
        class="swiper freebook_consultant_ul mh11"
        :options="swiperOption"
        :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true"
    >

        <swiper-slide class="item" 
            v-for="sc in scItems" 
            :key="`main-sc-item-${sc.id}`"  
        >
            <a class="carousel-shadow" @click="$router.push(`/scInfo/${sc.id}`)">
                <dl>
                    <dt>
                        <p>{{sc.name}}<span>{{ sc.shopName  }} 전시장</span></p> 
                        <span v-if="sc.certificationYn == 'Y'"><img :src="resource.imgIconCertified2">인증</span>
                    </dt>
                    <dd>
                        <span v-for="(rank, idx) in getRankingList(sc)" :key="`sc-${sc.id}-keyword-${idx}`">{{rank.keyword}}</span>
                    </dd>
                </dl>
                <figure>
                    <img :src=" sc.attUrl ? sc.attUrl : resource.imgIconUser">
                    <!--
                    <span v-if="sc.reviewCount > 9">
                        <img :src="resource.imgIconGood2" style="height:12px">{{ getRateGood(sc) }}%
                    </span>
                    -->
                    
                </figure>
                <p>
                    
                    <span><img v-if="sc.brandAttUrl" :src="sc.brandAttUrl">{{ sc.dealerName }}</span>
                    <span style="color:#003594; text-shadow:none">
                        <i class="fas fa-star"></i> 
                        {{reviewRatingAvg(sc.reviewSum, sc.reviewTotal)}}({{sc.total}}명)
                    </span>
                </p>
                <!--
                <figcaption>
                    <dl>
                        <dt>{{sc.name}}
                            <span class="dd" v-if="sc.certificationYn == 'Y'">
                                <div style="padding:0px;"><img :src="resource.imgIconCertified2">&nbsp;인증</div>
                            </span>
                        </dt>
                        <dd v-if="sc.reviewCount > 9">
                            <span v-for="(rank, idx) in getRankingList(sc)" :key="`sc-${sc.id}-keyword-${idx}`">{{rank.keyword}}</span>
                        </dd>
                    </dl>
                    <div class="flex_col">
                        <span>{{ sc.shopName  }}</span>
                        <span> <img v-if="sc.brandAttUrl" :src="sc.brandAttUrl">{{ sc.dealerName }}</span>
                    </div>
                </figcaption>
                -->
            </a>
        </swiper-slide>
    </swiper>

</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';
export default {
    name:'MainSc',
    mixins: [ NumberFormatMixin ],
    components: {
    },
    props: {
        onload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            swiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 1.3, //화면에 slide 노출 개수
            },
            
            scItemsOnload: [],
            scItems: [],
        }
    },
    computed: {
        ...mapState({
            // scItems : state => state.sc.items,
            DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SC_DETAIL_SCORE,
            resource: state => state.resource,
            // onload: state => state.common.onload,
        }),
        ...mapGetters([
            'viewShopAttUrl'
        ])
    },
    watch: {
        onload(val) {
            if(val) {
                this.scItems = this.scItemsOnload;
            }
        }
    },
    created () {
        
    },
    mounted () {
    },

    methods: {
        async getItems(){
            await this.$store.dispatch('GET_SC_LIST_PAGE',{
                size:5,
                orderby: "MAIN",
                lat : this.$store.state.currentLocationLat,
                har : this.$store.state.currentLocationHar,
            })
            .then((data)=>{
                this.scItemsOnload = data.content;
            }).catch((e)=> {
                throw e;
            });
        },

        getRateGood(data) {
            return this.$_getRateGood(data.good, data.normal, data.bad)
        },
        getRankingList(data) {
            let result = this.$_getRankingList([data.detailA
                                                , data.detailB
                                                , data.detailC
                                                , data.detailD
                                                , data.detailE
                                                , data.detailF]);

            result.forEach( (item) => {
                item.keyword = this.DETAIL_SCORE[item.type].content;
            })

            result.length = 2;
            
            return result;
        }
    }
}
</script>

<style scoped>

</style>